import type { NetworkingMapResponse } from "./networkingMapTypes";

/** The center is the logged-in person: every edge starts from them. */
export function getRootId(data: NetworkingMapResponse): string | undefined {
  return (
    data.edges[0]?.data.source ??
    data.nodes.find((node) => node.data.affinityPercent == null)?.data.id
  );
}
